import React, {useEffect, useRef} from "react"
import gsap from "gsap";
import Block from "./Elements/Block";

import styles from "./Introduction.module.scss";
import Button from "./Global/Button";
import ImageText from "./Elements/ImageText";

import image from "../images/masthead-image.png";
import imageRet from "../images/masthead-image@2x.png";
import imageWebp from "../images/masthead-image.webp";
import imageWebpRet from "../images/masthead-image@2x.webp";
import imageMobile from "../images/masthead-mobile.jpg";

import src from "../images/masthead-bg.jpg";
import srcRet from "../images/masthead-bg@2x.jpg";
import webp from "../images/masthead-bg.webp";
import webpRet from "../images/masthead-bg@2x.webp";

import Content from "./Elements/Content";
import Timeline from "../partials/Timeline";

export default function Introduction () {
    const button = useRef(null);

    useEffect(() => {
        const style = window.getComputedStyle(document.querySelector('body'));
        const buttonLink = button.current.querySelector('a');

        gsap.set(button.current, {
            width: buttonLink.getBoundingClientRect().width,
            height: buttonLink.getBoundingClientRect().height,
        });

        window.addEventListener('scroll', () => {
            const buttonRect = button.current.getBoundingClientRect();

            if (buttonRect.bottom < 0 && !button.current.classList.contains('animated')) {
                gsap.set(buttonLink, {
                    opacity: 0,
                    position: 'fixed',
                    bottom: 30,
                    right: 30,
                    zIndex: 9,
                    backgroundColor: style.getPropertyValue('--green3'),
                    color: 'white',
                    marginBottom: 0,
                    onComplete: () => {
                        gsap.to(buttonLink, .3, {
                            opacity: 1
                        })

                        button.current.classList.add('animated');
                    }
                })
            }
        })
    }, []);

    return (
        <Content>
            <Block classname={styles.Main} color={'white'} container={true} background={{src, srcRet, webp, webpRet}} mobile={imageMobile}>
                <h1>
                    <strong>
                        Voitures autonomes,
                    </strong>
                    révolution industrielle <br/> en route !
                </h1>

                <div className={styles.ButtonWrapper} ref={button}>
                    <Button text={'Investissez'} target={'_blank'} url={'https://ad.doubleclick.net/ddm/clk/516214658;324089622;j'}/>
                </div>

                <p className={'large size-6 ml-4'}>
                    Désormais une réalité, le véhicule autonome passe la vitesse supérieure. Alors que le marché automobile mondial devrait atteindre 9.000 milliards de dollars d’ici 2030, celui des voitures autonomes pourrait pour sa part croître de 56 milliards de dollars en 2020 à 220 milliards de dollars d’ici 2025. Une croissance qui devrait permettre aux entreprises à la pointe de la technologie et d’autres composants des véhicules autonomes de récolter d’énormes avantages…
                </p>

                <ImageText image={{src: image, srcRet: imageRet, webp: imageWebp, webpRet: imageWebpRet}} classname={[styles.Content, 'rtl'].join(' ')}>
                    <p>
                        Bardée de capteurs capables d’analyser la route en temps réel, de caméras et de radars avec une intelligence artificielle, la voiture dite autonome, qui doit permettre de circuler sans intervention humaine dans des conditions de circulation réelles, semble avoir tout pour plaire aux consommateurs, présentant des avantages notamment sur les questions d’autonomie, ou encore celle de la mobilité des personnes en situation de handicap. Qu’elle soit partiellement ou complètement autonome, elle pourrait également apporter des réponses concernant la sécurité et l'erreur humaine. Les problèmes de distractions humaines, de fatigue et parfois d'endormissement au volant, qui provoquent de nombreux accidents, pourraient être considérablement réduits par les véhicules autonomes.
                    </p>

                    <p>
                        Les voitures ne sont pas les seules concernées pour devenir autonomes. Drones, trains, ou encore bateaux se sont également positionnés sur le marché avec de nombreux projets en phase de test ou déjà en exercice. Mais pour pouvoir réussir cette révolution, de nombreux investissements doivent être faits, que ce soit au niveau des marchés, des compétences, des infrastructures mais aussi des constructeurs automobiles, qui vont travailler encore plus avec les fabricants de logiciels. Si la voiture autonome a d’ores et déjà prouvé qu’elle était techniquement réalisable, l’un de ses principaux défis est désormais de démontrer qu’elle est sûre…
                    </p>
                </ImageText>
            </Block>

            <Block container={false} background={'white'} classname={[styles.Timeline, 'navigation--1'].join(' ')}>
                <div className="container">
                    <span className="subtitle">
                        L’histoire de la <br/>
                        voiture autonome
                    </span>
                </div>

                <Timeline/>
            </Block>
        </Content>
    )
}
